window.addEventListener('OpusCartChange', (event)=>{
    const data = event.detail;
    const itemsCount = data.item_count;
    const iconCart = document.querySelector('a#cart-icon-bubble');
    const cartCount = document.querySelector('div.cart-count-bubble');
  
    if (!!itemsCount && itemsCount >= 0 && !cartCount) {
      const cartCountNew = document.createElement('div');
      cartCountNew.classList.add('cart-count-bubble') ;
      iconCart?.appendChild(cartCountNew);
    }
});


